import React from 'react';

import ReactDOM from 'react-dom';
 
import KeeVue from '../base/KeeVue.js'
 import { Button } from '@jd/find-react';
import $ from 'jquery';

//
 
export default class FsCodeEditor extends KeeVue {
	constructor(props) {
		super(props);

		this.state = {
			isShow: false,
			randId: this.getRandString(),
			isShowMenu: false,
			editor: null,
			contentValue: '',
		}

	}

	componentDidMount() {
		this.registComponent();
		var that = this;
		if (this.props.editable ) {
			setTimeout(function() {
				that.initEditor();
			}, 50);
		} else {
			if (typeof Prism !== "undefined") {
				window.Prism.highlightAll();
			}
		}
	}

	getData=()=>{
		this.state.contentValue = this.state.editor.getValue();
		this.props.component.value = this.state.contentValue;
		if (this.props.editable === true) {
			if (this.state.editor !== null) {
				return this.state.contentValue;
			}
		}
		return this.props.component.value;
	}
	isHasError=()=>{
		if (this.state.editor !== null) {
			if ($("#" + this.state.randId + " .ace_error").length > 0) {
				return true;
			}
		}
		return false;
	}
	format=()=>{
		var js_source = this.state.editor.getValue();
		if (this.props.component.cp.mode !== 'css') {
			var fjs = window.js_beautify(js_source, 1, "\t");
			this.state.editor.setValue(fjs);
		} else {
			var fjs = window.cssbeautify(js_source, {
				indent: '  ',
				openbrace: 'separate-line',
				autosemicolon: true
			});
			this.state.editor.setValue(fjs);
		}
		this.state.editor.clearSelection();
		this.refresh();
	}
	initEditor=()=>{
		var that = this;
		 
		let el = document.getElementById(this.state.randId);
 
			
		if(this.props.editable&&el)
		{
			this.state.editor = window.ace.edit(this.state.randId);
			this.state.editor.setTheme("ace/theme/clouds");
			if (!this.props.component.cp.mode  ) {
				this.state.editor.session.setMode("ace/mode/javascript");
			} else {
				this.state.editor.session.setMode("ace/mode/" + this.props.component.cp.mode);
			}
			this.state.editor.setFontSize(16);
			if (true === this.props.editable) {
				this.state.editor.setReadOnly(false);
			} else {
				this.state.editor.setReadOnly(true);
			}
			this.state.editor.setOption("wrap", "free")
			window.ace.require("ace/ext/language_tools");
			this.state.editor.setOptions({
				enableBasicAutocompletion: true,
				enableSnippets: true,
				enableLiveAutocompletion: true
			});
			if (this.props.component.value === null) {
				this.state.editor.setValue("");
			} else {
				//alert("ssssss"+this.props.component.value);
				this.state.editor.setValue(this.props.component.value, -1);
				this.state.editor.clearSelection();
			}
			this.state.editor.on("change", function(e) {
				that.state.contentValue = that.state.editor.getValue();
			})
			var that = this;
			setTimeout(()=>{
				this.state.editor.setValue(this.props.component.value, -1);
				this.state.editor.clearSelection();
			},600);
			this.refresh();
		}
		
	}
	setContent=(value)=>{
		if (this.props.editable === true) {
			if (this.state.editor !== null) {
				if (value !== null) {
					this.state.editor.setValue(value, -1);
					this.state.editor.clearSelection();
				} else
					this.state.editor.setValue("");
			} else {
				this.initEditor();
			}
		}
		this.refresh();
	}
	find=()=>{
		this.state.editor.execCommand("find");
	}

	render() {
		//alert(this.state.randId);
		
		let style = JSON.parse(JSON.stringify(this.props.component.style));
		return ( 
		
			<div >
			 
			{
				this.props.editable?<div className="kee-code-eitor-frame"  >
				
				<div  style={{"position":"absolute","top":"5px","right": "60px","width":"35px","height":"30px","zIndex": "80"}}>  
					<Button  onClick={this.find} size="mini">搜索</Button> 
				</div>
				<pre id={this.state.randId} className="ace_editor " style={style}  > </pre>
			</div>
			:
			<pre style="border-radius: 8px;" ><code class="language-javascript">{this.props.component.value}</code></pre>
			} 
			</div>
		
		);
	}
}
